/* Keyboard access to the existing Rebuy cart, on Our Brands only. */
(() => {
  const trigger = document.querySelector('[data-family-cart-trigger]');
  if (!trigger || trigger.dataset.familyCartBound) return;
  trigger.dataset.familyCartBound = 'true';
  let keyboardOpened = false;
  let keyboardWasVisible = false;
  let observedDrawer = null;
  let stateObserver = null;

  const syncCartState = () => {
    const drawer = document.getElementById('rebuy-cart');
    if (!drawer) return;
    if (drawer !== observedDrawer) {
      if (stateObserver) stateObserver.disconnect();
      observedDrawer = drawer;
      stateObserver = new MutationObserver(queueCartState);
      stateObserver.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
    trigger.setAttribute('aria-controls', drawer.id);
    trigger.setAttribute('aria-expanded', String(drawer.getAttribute('aria-hidden') === 'false'));
  };

  // Rebuy's Vue-bound visibility attribute can update after its show/hide event.
  const queueCartState = () => requestAnimationFrame(() => {
    syncCartState();
    if (keyboardOpened && observedDrawer && observedDrawer.getAttribute('aria-hidden') === 'false') keyboardWasVisible = true;
    if (keyboardOpened && keyboardWasVisible && observedDrawer && observedDrawer.getAttribute('aria-hidden') === 'true') {
      keyboardOpened = false;
      keyboardWasVisible = false;
      trigger.focus({ preventScroll: true });
    }
  });

  trigger.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (event.repeat) return;
    const smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (smartCart && typeof smartCart.show === 'function') {
      keyboardOpened = true;
      keyboardWasVisible = false;
      smartCart.show();
      queueCartState();
    } else {
      // Keep the native destination usable if the third-party drawer is unavailable.
      window.location.assign(trigger.href);
    }
  }, true);

  document.addEventListener('rebuy:smartcart.ready', queueCartState);
  document.addEventListener('rebuy:smartcart.show', queueCartState);
  document.addEventListener('rebuy:smartcart.hide', queueCartState);
  syncCartState();
})();
